import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { TextsContainer } from '../../../ui/Select/styled';

export const selectStyles = css`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 14px;
  padding: 7.5px 15px;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
    background-color: ${({ theme }) => theme.colors.background.primary};
  }

  ${TextsContainer} {
    width: 100%;
  }
`;

export const SelectContentContainer = styled.div`
  label {
    height: 54px;
    padding: 0;
    border-radius: 14px;

    &::after {
      display: none;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.background.tertiary};
    }

    @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      padding: 0 15px;
      height: 44px;
    }
  }
`;

export const selectPopoverStyles = css`
  padding-top: 5px;
  padding-bottom: 10px;
  max-height: 325px;
  overflow-y: scroll;

  &:not(:has(label:nth-of-type(8))) {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const chipsStyles = css`
  height: 44px;
  padding: 13px 15px;
  border-radius: 100px;

  > span {
    white-space: nowrap;
  }
`;

export const OptionsWrapper = styled(FlexibleDiv)`
  gap: 10px;
  flex-wrap: wrap;
`;
